import gettext from '@sdk/lang/gettext';
import { Controller } from 'react-hook-form';

import { AttachmentsFieldInner } from './AttachmentsFieldInner';

export const AttachmentsField = () => (
  <Controller
    name="attachments"
    render={({ field: { onChange } }) => <AttachmentsFieldInner onChange={onChange} />}
    rules={{
      validate: (attachments) =>
        attachments.length <= 10 || gettext('* Please reduce the number of attachments to 10.'),
    }}
  />
);
